import type { PropertyStatus, PropertyStrategy, PropertyType, UnitStatus } from '@portfolio-manager/sdk';

export const PROPERTY_TYPES: PropertyType[] = [
  'single_family',
  'multi_family',
  'condo',
  'townhouse',
  'land',
  'commercial',
];

export const PROPERTY_STRATEGIES: PropertyStrategy[] = ['brrrr', 'rental', 'flip', 'hold'];

export const PROPERTY_STATUSES: PropertyStatus[] = [
  'prospect',
  'under_contract',
  'rehab',
  'operating',
  'listed',
  'sold',
  'dead',
];

export const UNIT_STATUSES: UnitStatus[] = ['vacant', 'turning', 'leased', 'offline'];

export const getPropertyTypeName = (type: PropertyType): string => {
  switch (type) {
    case 'single_family':
      return 'Single family';
    case 'multi_family':
      return 'Multi family';
    case 'condo':
      return 'Condo';
    case 'townhouse':
      return 'Townhouse';
    case 'land':
      return 'Land';
    case 'commercial':
      return 'Commercial';
    default:
      return 'Unknown';
  }
};

export const getPropertyStrategyName = (strategy: PropertyStrategy): string => {
  switch (strategy) {
    case 'rental':
      return 'Rental';
    case 'flip':
      return 'Flip';
    case 'brrrr':
      return 'BRRRR';
    case 'hold':
      return 'Hold';
    default:
      return 'Unknown';
  }
};

export const getPropertyStatusName = (status: PropertyStatus): string => {
  switch (status) {
    case 'prospect':
      return 'Prospect';
    case 'under_contract':
      return 'Under contract';
    case 'rehab':
      return 'Rehab';
    case 'operating':
      return 'Operating';
    case 'listed':
      return 'Listed';
    case 'sold':
      return 'Sold';
    case 'dead':
      return 'Dead';
    default:
      return 'Unknown';
  }
};

export const getUnitStatusName = (status: UnitStatus): string => {
  switch (status) {
    case 'vacant':
      return 'Vacant';
    case 'turning':
      return 'Turning';
    case 'leased':
      return 'Leased';
    case 'offline':
      return 'Offline';
    default:
      return 'Unknown';
  }
};
